module.exports = __webpack_public_path__ + "@/assets/img/home-heart.44fc53bb.svg";